import React from 'react'
import Blog from './Blog'
import Mainbody from './Mainbody'
import Models from './Models'
import Offers from './Offers'

export default function Home() {
  return (
<>
<Mainbody/>
<Blog/>
<Offers/>
<Models/>
</>
  )
}
